module.exports = __webpack_public_path__ + "static/images/fail01.6ad6b40.png";